import { motion, useTransform, type MotionValue } from 'motion/react';
import type { CSSProperties, ReactNode } from 'react';

interface Props {
  // Scroll progress (0 → 1) of the chaos→order widget.
  progress: MotionValue<number>;
  // Stagger order so the cards don't all collapse at the same instant.
  index: number;
  // Resting (scattered) position.
  position: CSSProperties;
  rotate: number;
  children: ReactNode;
}

// A scattered "chaos" source card that shrinks + fades out as the resolve
// scrubs with scroll, leaving the single ordered card behind.
export const ScatCard = ({ progress, index, position, rotate, children }: Props) => {
  const start = index * 0.04;
  const scale = useTransform(progress, [0.05 + start, 0.45 + start], [1, 0.4]);
  const opacity = useTransform(progress, [0.1 + start, 0.42 + start], [1, 0]);
  // Parallax: cards drift up at slightly different rates as they collapse.
  const y = useTransform(progress, [0, 0.6], [0, -24 - index * 5]);
  return (
    <motion.div className="scat" style={{ ...position, rotate, scale, opacity, y }}>
      {children}
    </motion.div>
  );
};
